const goTo = (dom, behavior = 'smooth') => {
    if (dom) {
        // Determine the position where to scroll
        // * 60 is header height 
        // * 12 is var(--space-medium) value, the space between boxes
        const safeAreaInsetTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--platform-safe-area-inset-top')) || 0;
        let top = dom?.getBoundingClientRect()?.y + (document?.documentElement?.scrollTop || document?.body?.scrollTop || 0) - 60 - 12 - safeAreaInsetTop;
        if (top < 0) {
            top = 0;
        }

        // ScrollTo
        window.scrollTo({
            top,
            behavior,
        });

        return true;
    }
    return false;
}

const getSelector = (selector) => selector ? typeof (selector) === 'function' ? selector() : selector : null;

export const scrollToElement = ((selector, forceDuration = null, delayDuration = 0) => {
    let previousScroll = null;
    setTimeout(() => {
        // Interval to wait the DOM element
        const interval = forceDuration !== null ? setInterval(() => {

            // Scroll change cancellation
            const currentScroll = window.scrollY;
            if (previousScroll !== null && previousScroll !== currentScroll) {
                clearInterval(interval);
                clearTimeout(timeout);
                return;
            }
            previousScroll = currentScroll;

            // Try to scroll
            if (goTo(getSelector(selector))) {
                clearInterval(interval);
            }

        }, 25) : null;

        // Detection timeout
        const timeout = forceDuration !== null ? setTimeout(() => {
            clearInterval(interval);
        }, forceDuration) : null;

        // Try to scroll
        if (goTo(getSelector(selector))) {
            clearInterval(interval);
            clearTimeout(timeout);
        }
    }, delayDuration);
});
